var questionary,
    userResponses = {},
    currentQuestion = 0,
    lastQuestion = 0,
    formSubmitted = !1,
    assessmentFormId = 60,
    assessmentCaptchaId;

const maturityApiUrl = process.env.MATURITY_ASSESSMENT_API_URL,
    captchaSitekeyInvisible = process.env.CAPTCHA_SITEKEY_INVISIBLE,
    websiteContactApiUrl = process.env.WEBSITE_CONTACT_API_URL;

//

function get_prevsite() {
    const urlParams = new URLSearchParams(window.location.search);
    let source = urlParams.get('utm_source');
    let medium = urlParams.get('utm_medium');

    // Verifica sessionStorage para el referente original
    let ref = sessionStorage.getItem('original_ref');
    if (!ref) {
        // Si no se almacena ningún referente original, utiliza document.referrer o 'direct traffic' 
        ref = document.referrer || 'direct traffic';
        sessionStorage.setItem('original_ref', ref);
    }

    // Verifica sessionStorage para el sitio anterior
    let prevsite = sessionStorage.getItem('prevsite');

    // Almacena el document.referrer actual como el sitio anterior para la próxima visita
    sessionStorage.setItem('prevsite', document.referrer || 'direct traffic');

    return { ref, prevsite, source, medium };
}


//


$(document).ready(function () {
    loadQuestionary().then(
        () => {
            bindEvents();
            $(".pagination-list").append(
                $(Object.keys(questionary).map(
                    i => `<li class="page ${i == 0 ? 'active' : ''}" data-page="${i}">${parseInt(i) + 1}</li>`
                ).join(""))
            );
            showTab(0);
            $("#loading-spinner").fadeOut("fast");
        },
        (e) => {
            console.log("Error loading questionary");
        }
    );
});

function isOptionSelected() {
    const chkOptions = $("#options-container .tab.active input[data-option]:checked");
    const noneOption = $("#option-none:checked");

    const checked = chkOptions.length > 0 || noneOption.length > 0;
    return checked;
}

function checkOptionSelected() {
    const selected = isOptionSelected();
    $("#nextBtn").attr("disabled", !selected);
}

function bindEvents() {
    $(document).on("change", "input[data-option]", function () {
        if ($(this).prop("checked")) $("#option-none").prop("checked", false)
        checkOptionSelected();
    }),
        $(document).on("change", "#option-none", function () {
            if ($(this).prop("checked")) $("#options-container .tab.active input[data-option]").each(function () { $(this).prop("checked", false) })
            checkOptionSelected();
        }),
        $("#prevBtn").click(function () {
            nextPrev(-1);
        }),
        $("#nextBtn").click(function () {
            nextPrev(1);
        }),
        $("#final-form").submit(onSubmitForm);
}
function showQuestion(e) {
    var t = JSON.stringify(questionary[e].text);
    (t = (t = t.substring(1)).replace('"', "")),
        $("#question").text(t),
        $("#question").html(t).show(),
        $("#question-number").html(e + 1);
}
function showOptions(e) {
    $("[data-question='" + (lastQuestion + 1) + "']").removeClass("active"),
        $("[data-question='" + (e + 1) + "']").addClass("active");
}
function disabledTimeout(e, t) {
    $(e).attr("disabled", "disabled"),
        setTimeout(() => {
            $(e).removeAttr("disabled");
        }, t);
}
function showTab(e) {
    var t = $(".tab");
    e >= t.length ||
        (showQuestion(e),
            showOptions(e),
            0 == e ? $("#prevBtn").hide() : $("#prevBtn").show(),
            e == t.length - 1
                ? $("#nextBtn .text").html("See my results")
                : $("#nextBtn .text").html("Next"),
            $(".pagination [data-page]").removeClass("active"),
            $(".pagination").find(`[data-page="${e}"]`).addClass("active")),
        e >= t.length ||
        (showQuestion(e),
            showOptions(e),
            0 == e ? $("#prevBtn").hide() : $("#prevBtn").show(),
            e == t.length - 1
                ? $("#nextBtn").addClass("btnResults")
                : $("#nextBtn").removeClass("btnResults"));
}
function nextPrev(e) {
    var t = $(".tab");
    readResponse(currentQuestion + 1),
        currentQuestion + e < t.length
            ? ((lastQuestion = currentQuestion), showTab((currentQuestion += e)))
            : ($("#Results").modal({ backdrop: "static", keyboard: !1 }),
                $("#Results").modal("show"));

    $("#option-none").prop("checked", userResponses[currentQuestion + 1] ? userResponses[currentQuestion + 1].selectedNone : false);
    checkOptionSelected();
}
function readResponse(questionId) {
    userResponses[questionId] = { questionId, selectedOptions: [], selectedNone: false };
    if ($("#option-none").prop("checked")) {
        userResponses[questionId].selectedNone = true;
    } else {
        $(`[data-question="${questionId}"]`)
            .find("input[data-option]:checked")
            .each(function () {
                let t = parseInt($(this).attr("data-option"));
                userResponses[questionId].selectedOptions.push(t + 1)
            })
    }

}
function getOptionScoreValue(e, t) {
    let o = questionary.find((t) => t.id == e);
    return parseInt(o.options[t].score);
}
function loadQuestionary() {
    return new Promise((e, t) => {
        readJsonFile("https://abstracta-static-assets.s3.amazonaws.com/maturity-assessment/questionary.json")
            .then((t) => {
                renderOptions((questionary = t)), e();
            })
            .catch((e) => {
                console.log(e), t();
            });
    });
}

function readJsonFile(e) {
    return new Promise((t, o) => {
        $.getJSON(e, function (e) {
            t(e);
        }).fail(function () {
            o("File " + e + " not found");
        });
    });
}
function renderOptions(e) {
    let html = "";
    e.forEach((e, t) => {
        (html += '<div class="tab" data-question="' + e.id + '">'),
            e.options.forEach((t, o) => {
                let n = "question" + e.id + "-option" + o;
                html += `
                    <div class="input-checkbox">
                        <input id="${n}" type="checkbox" data-option="${o}" />
                        <label class="input-checkbox-label" for="${n}"> 
                            <span class="input-checkbox-toggle"></span>
                            <span class="input-checkbox-label-content">
                                ${t.text} 
                            </span>
                        </label>
                    </div>`;
            }),
            (html += "</div>");
    });
    $("#options-container").html(html);
}

function onSubmitForm(e) {
    e.preventDefault();
    if (!formSubmitted) {
        if (validateForm()) {
            grecaptcha.execute(assessmentCaptchaId);
        }
        return !1;
    }
}

async function submitResults() {
    $(".form-error").remove();
    formSubmitted = true;
    //
    let referrerData = get_prevsite();
    let ref = referrerData.ref;
    let prevsite = referrerData.prevsite;
    let source = referrerData.source || "";
    let medium = referrerData.medium || "";
    let gdprVal34 = $("#field_34").prop("checked");
    let suscription = $("#field_suscription").prop("checked");
    //
    let acUserData = {
        firstname: $("#fullname").val(),
        email: $("#email").val(),
        company: $("#organization").val(),
        companysize: $("#company-size").val(),
        jobtitle: $("#role").val(),
        form: assessmentFormId,
        device: window.get_device_type(),
        ref: ref,
        prevsite: prevsite,
        url: window.location.href,
        //
        source: source,
        medium: medium,
        suscription: suscription,
        gdpr2019: gdprVal34
        //,
    };
    const captchaResponse = grecaptcha.getResponse(assessmentCaptchaId);
    $("#btn-submit").addClass("loading");
    try {
        const responses = Object.entries(userResponses).map(([key, { questionId, selectedOptions }]) => { return { questionId, selectedOptions } })
        const { resultId } = await saveResult(acUserData.email, responses, acUserData, captchaResponse);
        if (!resultId) throw new Error("");
        $("#fullname").val("");
        $("#email").val("");
        $("#role").val("");
        $("#organization").val("");
        location.href = `results.html?resultId=${resultId}`;
    }
    catch (e) {
        grecaptcha.reset(assessmentCaptchaId);
        $("#btn-submit").after("<p class='form-error error-field'>An error has occurred, please try again in a few seconds</p>");
    }
    finally {
        $("#btn-submit").removeClass("loading");
        formSubmitted = false;
    }
}

function validateForm() {
    $(".error-field").remove(), $("#error-company-size").remove();
    $("#company-size").removeClass("error");
    var e = $("#fullname"),
        t = $("#organization"),
        o = $("#email"),
        n = $("#role"),
        i = $("#company-size")
        
    let res = !0;
    return (
        controls_fields(e) || (res = !1),
        controls_fields(t) || (res = !1),
        controls_fields(n) || (res = !1),
        controls_fields(o) || (res = !1),
        
        (i.val() && !i.val().includes("Company size")) ||
        ($(i).addClass("error"),
            $(i).after(
                "<p id='error-company-size' class='error-field' style='top:0px'>Obligatory field</p>"
            ),
            (res = !1)),
        !!res
    );
}

function saveResult(email, userResponses, acUserData, captchaResponse) {
    return new Promise((n, i) => {
        const data = { userResponses, email, acUserData, captcharesponse: captchaResponse };
        $.ajax({
            type: "POST",
            url: `${maturityApiUrl}/result`,
            data: JSON.stringify(data),
            contentType: "application/json",
            success: function (res) {
                n(res);
            },
            error: function (e) {
                i(e);
            },
        });
    });
}

window.initCaptchas = function () {
    assessmentCaptchaId = grecaptcha.render("assessment-captcha", {
        sitekey: captchaSitekeyInvisible,
        size: "invisible",
        callback: submitResults,
        badge: "inline"
    });
}

function setCookie(e, t, o) {
    var n = new Date();
    n.setTime(n.getTime() + 864e5 * o),
        (document.cookie = e + "=" + t + ";path=/;expires=" + n.toGMTString());
}
function deleteCookie(e) {
    setCookie(e, "", -1);
}
